import {
  SaveConditionalGroup,
  SaveConditionalRule,
  SaveTriggerRequest,
} from 'workflow-definition/openapi';
import {
  OptionsData,
  SaveConditionalValue,
  TriggersFormStructure,
} from '../models';

const NO_VALUE_OPS = ['IsCompleted', 'IsIncomplete'];

export function mapFormToSaveTriggerRequest(
  triggersForm: TriggersFormStructure
): SaveTriggerRequest {
  return {
    triggers: triggersForm.triggers.map((trigger, triggerIndex) => ({
      order: triggerIndex,
      opr: trigger.conditionalGroup.opr,
      rules: (trigger.conditionalGroup.rules ?? []).map((rule, ruleIndex) => {
        const comp = rule.conditionalRule.comp.value;
        const isNoValueOp = NO_VALUE_OPS.includes(comp ?? '');
        return {
          order: ruleIndex,
          val1: {
            segmentRefId: rule.conditionalRule.val1?.segmentRefId,
            stepRefId: rule.conditionalRule.val1?.stepRefId,
            actionRefId: rule.conditionalRule.val1?.actionRefId,
            componentRefId: rule.conditionalRule.val1?.componentRefId,
            jsonFieldId: rule.conditionalRule.val1?.jsonFieldId,
            fixedValue: rule.conditionalRule.val1?.fixedValue,
            propertyName: null,
          } as SaveConditionalValue,
          comp,
          val2: isNoValueOp
            ? undefined
            : ({
                segmentRefId: rule.conditionalRule.val2?.segmentRefId,
                stepRefId: rule.conditionalRule.val2?.stepRefId,
                actionRefId: rule.conditionalRule.val2?.actionRefId,
                componentRefId: rule.conditionalRule.val2?.componentRefId,
                jsonFieldId: rule.conditionalRule.val2?.jsonFieldId,
                fixedValue: rule.conditionalRule.val2?.fixedValue,
                propertyName: null,
              } as SaveConditionalValue),
          opr: rule.conditionalRule.opr,
        };
      }),
    })),
  };
}

export function mapResponseToFormTrigger(
  response: SaveTriggerRequest
): TriggersFormStructure {
  return {
    triggers: (response.triggers ?? []).map(
      (trigger: SaveConditionalGroup, triggerIndex) => {
        return {
          conditionalGroup: {
            id: trigger.id ?? null,
            order: triggerIndex,
            opr: trigger.opr,
            rules: (trigger.rules ?? []).map(
              (rule: SaveConditionalRule, ruleIndex) => {
                return {
                  conditionalRule: {
                    id: rule.id ?? null,
                    order: ruleIndex,
                    val1: {
                      segmentRefId: rule.val1?.segmentRefId,
                      stepRefId: rule.val1?.stepRefId,
                      actionRefId: rule.val1?.actionRefId,
                      componentRefId: (rule.val1 as SaveConditionalValue)
                        ?.componentRefId,
                      jsonFieldId: rule.val1?.jsonFieldId,
                      fixedValue: rule.val1?.fixedValue,
                      label: rule.val1?.propertyName,
                    },
                    comp: {
                      value: rule.comp,
                      label: DROPDOWN_OPERATORS.find(
                        item => item.value === rule.comp
                      )?.label,
                    },
                    val2: {
                      segmentRefId: rule.val2?.segmentRefId,
                      stepRefId: rule.val2?.stepRefId,
                      actionRefId: rule.val2?.actionRefId,
                      componentRefId: (rule.val2 as SaveConditionalValue)
                        ?.componentRefId,
                      jsonFieldId: rule.val2?.jsonFieldId,
                      fixedValue: rule.val2?.fixedValue,
                      label: rule.val2?.propertyName ?? rule.val2?.fixedValue,
                    },
                    opr: rule.opr,
                  },
                };
              }
            ),
          },
        };
      }
    ),
  };
}

export const DROPDOWN_OPERATORS: OptionsData<string>[] = [
  {
    label: 'Is Equal To',
    value: 'Equal',
  },
  {
    label: 'Is Different Than',
    value: 'NotEqual',
  },
  {
    label: 'Greater Than',
    value: 'GreaterThan',
  },
  {
    label: 'Less Than',
    value: 'LessThan',
  },
  {
    label: 'Greater than or equal to',
    value: 'GreaterThanOrEqual',
  },
  {
    label: 'Less than or equal to',
    value: 'LessThanOrEqual',
  },
];
